"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _components = require("@/components");
var _apply = require("@/api/data/apply");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Apply',
  components: {
    PageInfo: _components.PageInfo
  },
  data: function data() {
    return {
      pagination: {
        page: 1,
        limit: 20,
        total: 100
      },
      querySelectOptions: [],
      searchForm: {
        app_name: undefined,
        state: undefined
      },
      dialogVisible: false,
      listData: [],
      isEdit: false,
      dataForm: {
        app_name: '',
        app_domain: '',
        state: '',
        app_secret: '',
        des: '',
        sort: ''
      },
      rules: {
        app_name: [{
          required: true,
          message: '请输入应用',
          trigger: 'blur'
        }],
        app_domain: [{
          required: true,
          message: '请输入应用入口',
          trigger: 'blur'
        }],
        state: [{
          required: true,
          message: '请输入状态',
          trigger: 'blur'
        }],
        des: [{
          required: true,
          message: '请输入描述',
          trigger: 'blur'
        }]
      }
    };
  },
  activated: function activated() {
    this.init();
  },
  created: function created() {
    this.init();
  },
  methods: {
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(page) {
        var params, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (page) this.pagination.page = page;
              params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchForm), this.pagination);
              _context.next = 4;
              return (0, _apply.getApplyList)(params);
            case 4:
              res = _context.sent;
              this.listData = res.data.list;
              this.pagination.total = res.data.total;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    /* 初始化相关内容 */init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.fetchData();
            case 2:
              this.querySelectOptions = this.listData.map(function (item) {
                return item.app_name;
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    addApp: function addApp() {
      this.isEdit = false;
      this.dialogVisible = true;
      this.dataForm = {
        app_name: '',
        app_domain: '',
        state: 1,
        app_secret: '',
        des: '',
        sort: 0
      };
    },
    tableEdit: function tableEdit(data) {
      var _this = this;
      this.isEdit = true;
      this.dialogVisible = true;
      this.dataForm = (0, _objectSpread2.default)({}, data);
      (0, _apply.getApply)(data.id).then(function (res) {
        _this.dataForm = res.data;
      }).catch(function (err) {
        _this.$message.error(err.msg);
      });
    },
    tableSwitch: function tableSwitch(data) {
      var _this2 = this;
      this.$confirm("\u6B64\u64CD\u4F5C\u5C06".concat(data.state === 1 ? '禁用' : '启用', "\u8BE5\u5E94\u7528, \u662F\u5426\u7EE7\u7EED?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params = {
          id: data.id,
          state: data.state === 1 ? 0 : 1
        };
        (0, _apply.changeState)(params).then(function (res) {
          _this2.$message.success('操作成功');
          _this2.fetchData();
        }).catch(function (err) {
          _this2.$message.error(err.msg);
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    onSave: function onSave() {
      var _this3 = this;
      this.$refs['appForm'].validate(function (valid) {
        if (valid) {
          if (!_this3.isEdit) {
            (0, _apply.addApply)(_this3.dataForm).then(function (res) {
              _this3.$message.success('添加成功');
              _this3.fetchData();
            }).catch(function (err) {
              _this3.$message.error(err.msg);
            });
          } else {
            (0, _apply.updateApply)(_this3.dataForm).then(function (res) {
              _this3.$message.success('编辑成功');
              _this3.fetchData();
            }).catch(function (err) {
              _this3.$message.error(err.msg);
            });
          }
          _this3.dialogVisible = false;
        } else {
          return;
        }
      });
    },
    resetForm: function resetForm() {
      this.$refs['appForm'].resetFields();
      this.dialogVisible = false;
    },
    /* 处理每页展示的数量改变事件 */handlePageSizeChange: function handlePageSizeChange(limit) {
      this.pagination.limit = limit;
      this.pagination.page = 1;
      // 重新加载表格数据
      this.fetchData();
    },
    /* 处理切页 */handlePageChange: function handlePageChange(page) {
      this.pagination.page = page;
      // 重新加载表格数据
      this.fetchData();
    }
  }
};
exports.default = _default;